<template>
  <div class="admin-container">
    <div class="admin-header">
      <h1>Billing Dashboard</h1>
    </div>

    <div class="admin-content">
      <div class="admin-nav">
        <ul class="nav-list">
          <li class="nav-item">
            <a href="#invoices" class="nav-link">Invoices</a>
          </li>
          <li class="nav-item">
            <a href="#payments" class="nav-link">Payments</a>
          </li>
          <li class="nav-item">
            <a href="#insurance" class="nav-link">Insurance Claims</a>
          </li>
          <li class="nav-item">
            <a href="#patients" class="nav-link">Patient Accounts</a>
          </li>
          <li class="nav-item">
            <a href="#codes" class="nav-link">Billing Codes</a>
          </li>
          <li class="nav-item">
            <a href="#reports" class="nav-link">Financial Reports</a>
          </li>
        </ul>
      </div>

      <div class="admin-main">
        <div class="content-section">
          <h2>Welcome to Billing Panel</h2>
          <p>Select an option from the navigation menu.</p>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, onMounted } from "vue";

const AreIdsShown = ref(true);
onMounted(() => {
  // console.log("onMounted() :      ADMIN >>>>");
});
</script>

<style scoped>
.admin-container {
  min-height: 100vh;
  background-color: #f5f5f5;
}

.admin-header {
  background-color: #2c3e50;
  color: white;
  padding: 1rem;
  text-align: center;
}

.admin-content {
  display: flex;
  min-height: calc(100vh - 80px);
}

.admin-nav {
  width: 250px;
  background-color: #34495e;
  padding: 1rem;
}

.nav-list {
  list-style: none;
  padding: 0;
  margin: 0;
}

.nav-item {
  margin-bottom: 0.5rem;
}

.nav-link {
  color: white;
  text-decoration: none;
  display: block;
  padding: 0.75rem;
  border-radius: 4px;
  transition: background-color 0.3s;
}

.nav-link:hover {
  background-color: #2c3e50;
}

.admin-main {
  flex: 1;
  padding: 2rem;
}

.content-section {
  background-color: white;
  padding: 2rem;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
</style>
